export function debounce(func, wait = 500, immediate) {
  /*
Returns a function that will not be triggered as long as it continues to be invoked. 
The function will be called after it stops being called for
N milliseconds. If `immediate` is passed, trigger the function on the
leading edge, instead of the trailing.
*/
  var timeout
  return function () {
    var context, args
    context = this
    args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}



// Throttle an event and emit a custom event
export function throttle(type, name, obj) {
  obj = obj || window;
  var running = false;
  var func = function () {
    if (running) {
      return;
    }
    running = true;
    requestAnimationFrame(function () {
      obj.dispatchEvent(new CustomEvent(name));
      running = false;
    });
  };
  obj.addEventListener(type, func);
};

export function equalHeights(selector) {
  let elements;
  let tallest = 0;

  if (typeof (selector) !== 'string') {
    elements = selector;
  } else {
    elements = document.querySelectorAll(selector);
  }

  for (let i = 0; i < elements.length; i++) {
    let ele = elements[i];
    // Reset any inline heights
    ele.style.height = "";
  }


  for (let i = 0; i < elements.length; i++) {
    let ele = elements[i];
    let eleHeight = ele.offsetHeight;
    tallest = (eleHeight > tallest ? eleHeight : tallest);
  }

  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = tallest + "px";
  }
}

export function equalWidths(selector, valueToAdd = 0) {
  let elements;
  let widest = 0;

  if (typeof (selector) !== 'string') {
    elements = selector;
  } else {
    elements = document.querySelectorAll(selector);
  }
  
  for (let i = 0; i < elements.length; i++) {
    let ele = elements[i];
    // Reset any inline widths
    ele.style.width = "";
  }

  for (let i = 0; i < elements.length; i++) {
    let ele = elements[i];
    let eleWidth = ele.offsetWidth;
    widest = (eleWidth > widest ? eleWidth : widest);
  }

  
  for (let i = 0; i < elements.length; i++) {
    elements[i].style.width = widest + valueToAdd + "px";
  }
}

// Reset height of elements to their natural height
export function setHeightAuto(selector) {
  let elements;

  if (typeof (selector) !== 'string') {
    elements = selector;
  } else {
    elements = document.querySelectorAll(selector);
  }

  for (let e of elements) {
    e.style.height = "auto";
  }
}




/**
 * watchAwaitSelector
 * * Uses mutation observer to watch for 'selector' involved in DOM changes (added, removed, class change, content change, etc)
 * @param {Function} callback A callback function to be run whenever DOM changes are detected, can be anonymous or named
 * @param {String} selector Element(s) to look for involved in DOM changes, you can watch multiple selectors by separating via comma '.class1, .class2, #id3'
 * @param {Node} rootNode Node to watch from, typically document
 * @param {Number} fallbackDelay Interval to be used if the browser does not support MutationObserver, value is in milliseconds (2000 = 2 seconds)
 */
export const awaitSelector = (selector, rootNode, fallbackDelay) => new Promise((resolve, reject) => {
  try {
    const root = rootNode || document
    const ObserverClass = MutationObserver || WebKitMutationObserver || null
    const mutationObserverSupported = typeof ObserverClass === 'function'
    let observer
    const stopWatching = () => {
      if (observer) {
        if (mutationObserverSupported) {
          observer.disconnect()
        } else {
          clearInterval(observer)
        }
        observer = null
      }
    }
    const findAndResolveElements = () => {
      const allElements = root.querySelectorAll(selector)
      if (allElements.length === 0) return
      const newElements = []
      const attributeForBypassing = 'data-awaitselector-resolved'
      allElements.forEach((el, i) => {
        if (typeof el[attributeForBypassing] === 'undefined') {
          allElements[i][attributeForBypassing] = ''
          newElements.push(allElements[i])
        }
      })
      if (newElements.length > 0) {
        stopWatching()
        resolve(newElements)
      }
    }
    if (mutationObserverSupported) {
      observer = new ObserverClass(mutationRecords => {
        const nodesWereAdded = mutationRecords.reduce(
          (found, record) => found || (record.addedNodes && record.addedNodes.length > 0),
          false
        )
        if (nodesWereAdded) {
          findAndResolveElements()
        }
      })
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true
      })
    } else {
      observer = setInterval(findAndResolveElements, fallbackDelay || 250)
    }
    findAndResolveElements()
  } catch (exception) {
    reject(exception)
  }
})

export const watchAwaitSelector = (callback, selector, rootNode, fallbackDelay) => {
  (function awaiter(continueWatching = true) {
    if (continueWatching === false) return
    awaitSelector(selector, rootNode, fallbackDelay)
      .then(callback)
      .then(awaiter)
  }())
}

export const createCookie =  function(name, value, days) {
  var expires;

  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
  } else {
      expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

export const readCookie = function(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ')
          c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

export const getSearchParameters = () => {
  var prmstr = window.location.search.substr(1);
  return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

export const transformToAssocArray = function ( prmstr ) {
  var params = {};
  var prmarr = prmstr.split("&");
  for ( var i = 0; i < prmarr.length; i++) {
    var tmparr = prmarr[i].split("=");
    params[tmparr[0]] = tmparr[1];
  }
  return params;
}